import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { DetachLabel, DetachLabelVariables } from 'types/graphql';
import LabelsApi from './Labels.api';
import { useLabelAttachmentsStore } from './labelAttachments.store';

export default function useLabelDetachment() {
  const [detachLabelMutation] = useMutation<DetachLabel, DetachLabelVariables>(LabelsApi.DetachLabel);
  const detachLabel = useLabelAttachmentsStore((state) => state.detachLabel);

  return useCallback(
    async (labelAttachmentId) => {
      detachLabel(labelAttachmentId);

      await detachLabelMutation({ variables: { id: labelAttachmentId } });
    },
    [detachLabel, detachLabelMutation]
  );
}
